/* BYC 2026-10-10：ヘッダーの常時表示、お気に入り（この端末に保存）、カートの個数表示 */
(function () {
  var KEY = 'byc_favorites';
  var ES = (document.documentElement.lang || '').slice(0, 2) === 'es';  /* 2026-10-19 スペイン語版：html lang が es のときスペイン語 */
  function get() { try { var a = JSON.parse(localStorage.getItem(KEY)); return Array.isArray(a) ? a : []; } catch (e) { return []; } }
  function save(a) { try { localStorage.setItem(KEY, JSON.stringify(a)); } catch (e) {} render(); document.dispatchEvent(new CustomEvent('byc:favorites-changed')); }
  function render() {
    var a = get();
    document.querySelectorAll('[data-byc-fav-count]').forEach(function (b) { b.textContent = a.length; b.hidden = !a.length; });
    document.querySelectorAll('[data-byc-fav]').forEach(function (btn) {
      var on = a.indexOf(btn.getAttribute('data-byc-fav')) > -1;
      btn.setAttribute('aria-pressed', on ? 'true' : 'false');
      var l = btn.querySelector('[data-byc-fav-label]');
      if (l) l.textContent = ES ? (on ? 'Agregado a favoritos' : 'Agregar a favoritos') : (on ? 'お気に入りに追加済み' : 'お気に入りに追加');
    });
  }
  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('[data-byc-fav]');
    if (!btn) return;
    e.preventDefault();
    var h = btn.getAttribute('data-byc-fav'), a = get(), i = a.indexOf(h);
    if (i > -1) a.splice(i, 1); else a.unshift(h);
    save(a);
  });
  window.addEventListener('storage', function (e) { if (e.key === KEY) render(); });
  window.BYCFav = { get: get, save: save, render: render };

  function refreshCart() {
    fetch((window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + 'cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (c) { document.querySelectorAll('[data-byc-cart-count]').forEach(function (b) { b.textContent = c.item_count; b.hidden = !c.item_count; }); })
      .catch(function () {});
  }
  document.addEventListener('byc:cart-updated', refreshCart);
  /* カートに入れたら個数を更新する（ページ側の処理には手を入れずに、カート追加の通信だけを見張る） */
  if (window.fetch) {
    var _f = window.fetch;
    window.fetch = function (input) {
      var p = _f.apply(this, arguments), u = typeof input === 'string' ? input : (input && input.url) || '';
      if (/\/cart\/(add|change|update|clear)/.test(u)) p.then(function () { setTimeout(refreshCart, 50); }).catch(function () {});
      return p;
    };
  }
  /* ロットのページにお気に入りボタンを付ける */
  var ph = window.BYC_PRODUCT_HANDLE, h1 = document.querySelector('.bycl-info h1');
  if (ph && h1 && !document.querySelector('[data-byc-fav]')) {
    var b = document.createElement('button');
    b.type = 'button'; b.className = 'byc-fav-btn'; b.setAttribute('data-byc-fav', ph); b.setAttribute('aria-pressed', 'false');
    b.innerHTML = '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" aria-hidden="true"><path d="M12 20.5s-7.5-4.6-9.3-9.2C1.4 8 3.4 4.5 6.9 4.5c2.1 0 3.6 1.2 5.1 3 1.5-1.8 3-3 5.1-3 3.5 0 5.5 3.5 4.2 6.8-1.8 4.6-9.3 9.2-9.3 9.2z"/></svg><span data-byc-fav-label>' + (ES ? 'Agregar a favoritos' : 'お気に入りに追加') + '</span>';
    h1.insertAdjacentElement('afterend', b);
  }
  window.addEventListener('pageshow', function (e) { if (e.persisted) refreshCart(); });

  var hd = document.querySelector('[data-byc-header]');
  if (hd) {
    var onScroll = function () { hd.classList.toggle('is-scrolled', window.scrollY > 24); };
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
    /* トップ：メニューバーの高さを測り、動画の舞台をその下から始める */
    if (hd.classList.contains('is-top')) {
      var de = document.documentElement;
      de.classList.add('byc-has-top-header');
      var setH = function () { de.style.setProperty('--byc-hh', Math.round(hd.getBoundingClientRect().height) + 'px'); };
      setH();
      if (window.ResizeObserver) new ResizeObserver(setH).observe(hd); else window.addEventListener('resize', setH);
    }
  }
  /* トップ：スクロールの誘導。旅の途中もずっと出しておき（終わり近くで消す）、始まったら文言を「次の場面へ」に変える */
  var sc = document.querySelector('.bycs-scroll'), trk = document.querySelector('.bycs-track');
  if (sc && trk) {
    var sp = sc.querySelector('span'), stg = sc.closest('.bycs-stage');
    var upd = function () {
      if (!stg) return;
      var r = trk.getBoundingClientRect(), hh = parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--byc-hh')) || 0;
      var started = r.top < hh - 4;
      if (sp) sp.textContent = ES ? (started ? 'Siguiente escena' : 'Empezar el viaje') : (started ? '次の場面へ' : '旅を始める');
      stg.classList.toggle('byc-hint', r.bottom > window.innerHeight * 1.6);
    };
    window.addEventListener('scroll', upd, { passive: true });
    window.addEventListener('resize', upd);
    upd();
    /* 2026-10-19 ボタンを押すと、次の場面の文が出るところ（場面の15%）まで進む */
    sc.addEventListener('click', function () {
      var scenes = trk.querySelectorAll('.bycs-scene[data-len]'), vh = window.innerHeight / 100;
      var top0 = trk.getBoundingClientRect().top + window.scrollY, now = window.scrollY - top0, acc = 0, dest = null;
      for (var i = 0; i < scenes.length; i++) {
        var len = (parseFloat(scenes[i].getAttribute('data-len')) || 100) * vh, at = acc + len * 0.15;
        if (i > 0 && at > now + 8) { dest = at; break; }
        acc += len;
      }
      if (dest === null) dest = acc;
      var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      window.scrollTo({ top: Math.round(top0 + dest), behavior: reduce ? 'auto' : 'smooth' });
    });
  }
  /* 全ページ：短い説明文（180字以内・2文以上）は、PCで文ごとに改行して読みやすくする。
     2026-10-20：「…。」の閉じかっこ（」』）»）は前の文に付けたまま改行する（」だけが次の行に落ちないように） */
  var mainEl = document.getElementById('byc-main');
  if (mainEl) {
    mainEl.querySelectorAll('p').forEach(function (p) {
      var t = p.textContent.trim();
      if (t.length > 180 || p.querySelector('br') || (t.match(/。/g) || []).length < 2) return;
      var w = document.createTreeWalker(p, NodeFilter.SHOW_TEXT), nodes = [], n;
      while ((n = w.nextNode())) nodes.push(n);
      nodes.forEach(function (node) {
        var parts = node.nodeValue.split(/(?<=。)(?![」』）)»])|(?<=。[」』）)»]+)(?=[「『（(«])/);
        if (parts.length < 2) return;
        var frag = document.createDocumentFragment();
        parts.forEach(function (part, i) {
          frag.appendChild(document.createTextNode(part));
          if (i < parts.length - 1 && /。[」』）)»]*$/.test(part)) {
            var s = document.createElement('span'); s.className = 'byc-br-pc'; s.appendChild(document.createElement('br')); frag.appendChild(s);
          }
        });
        node.parentNode.replaceChild(frag, node);
      });
      /* 最後の文の後ろに付いた改行は消す */
      var last = p.querySelectorAll('.byc-br-pc'); last = last[last.length - 1];
      if (last && !(last.nextSibling && last.nextSibling.textContent.trim())) last.remove();
    });
  }
  render();
})();
